import type { FeatureFilterOption } from "@next-platform/client-common-core";

import { getBaseRefinementValue } from "@/components/search/utils/filterSanitizers";

export default function getSupportedFeatureRefinements(values: readonly string[], options: readonly FeatureFilterOption[]): string[] {
  const supportedValues = new Set<string>(options.map(({ value }) => value));
  return values.filter((value) => supportedValues.has(getBaseRefinementValue(value)));
}
